import { FeatureFlagId } from 'types/featureflags';

export const FEATURE_FLAGS_DEFAULTS: Record<FeatureFlagId, boolean> = {
	[FeatureFlagId.PRESERVE_QUERY_PARAMS]: false
};
